/* eslint-disable */

import { gql } from '@apollo/client';
import axios from 'axios';
import clientApollo from './clientApollo';
import { subscribeToConfigChanges } from '~/common/helpers/environment';

let currentApiKey = null;
let currentEndpoint = null;

// Subscribe to config changes to get the latest API key and endpoint
subscribeToConfigChanges(config => {
  if (config) {
    if (config.PIPELINE_INTERCOM_FALLBACK_APIKEY) {
      currentApiKey = config.PIPELINE_INTERCOM_FALLBACK_APIKEY;
    }
    if (config.PIPELINE_INTERCOM_FALLBACK_ENDPOINT) {
      currentEndpoint = config.PIPELINE_INTERCOM_FALLBACK_ENDPOINT;
    }
  }
});

const intercom = {
  create: () => {
    return clientApollo.query({
      query: gql`
        query intercom {
          intercom
        }
      `
    });
  },
  async createFallbackMessage(params) {
    try {
      // Get the current API key and endpoint from the subscription
      const apiKey =
        currentApiKey || import.meta.env.VITE_PIPELINE_INTERCOM_FALLBACK_APIKEY;
      const endpoint =
        currentEndpoint ||
        import.meta.env.VITE_PIPELINE_INTERCOM_FALLBACK_ENDPOINT;

      const { data } = await axios.post(endpoint, params, {
        headers: {
          apikey: apiKey
        }
      });
      return data;
    } catch (e) {
      throw new Error(e);
    }
  }
};

export default intercom;
